export default __webpack_public_path__ + "static/media/cnp20_3.89530ec6.png";